<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <div>
          <div v-once :id="pageTop" class="d-flex justify-center pt-4">
            <v-img
                :src="require('@/assets/merchant.png')"
                max-width="200"
                max-height="auto"
                alt=""
            ></v-img>
          </div>
          <v-flex class="headline font-weight-light py-3">ADD MERCHANDISE</v-flex>
        </div>
      </v-flex>
      <v-flex xs12>
        <s-s-merchandise-form :product_id="productId"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import SSMerchandiseForm from '@/components/SelfServes/SSMerchandiseForm';
import SSScroll from '@/services/SelfServes/SSScroll';
import SSUI from '@/services/SelfServes/SSUI';

export default {
  name: 'SSAddMerchandise',
  metaInfo: {
    titleTemplate: '%s - Self-Serve | Add Merchandise',
  },
  components: {
    SSMerchandiseForm,
  },
  data () {
    return {
      productId: null,
      pageTop: 'add-merchandise-img'
    }
  },
  created() {
    this.productId = this.$router.currentRoute.params.id;
  },
  mounted() {
    if (!this.$store.getters.ssAvailableStepMerchandise) {
      this.$router.push({name: 'SSDelivery'});
    }
    this.$nextTick(() => {
      SSScroll.scrollTo(this.pageTop);
    });
    SSUI.disableZoom();
  },
}
</script>
